'use client';

import { notFound } from 'next/navigation';
import { format, parseISO } from 'date-fns';
import dynamic from 'next/dynamic';
import { use, useState } from 'react';
import { getPostFromParams } from '../helper';
import ListenAction from '@/components/PostActions/ListenAction';
import { Amplify, Auth, Storage } from 'aws-amplify';
import useLocalStorage from '@/hooks/useLocalStorage';
import { Mdx } from '@/components/MdxProvider/MdxProvider';

Amplify.configure({
  Auth: {
    identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',
    region: 'eu-central-1',
  },
  Storage: {
    AWSS3: {
      bucket: 'audiogeneratortexttospeechoutputbucket',
    },
  },
});

interface PostProps {
  params: {
    slug: string;
  };
}

const DynamicAudioPlayer = dynamic(
  () => import('@/components/AudioPlayer/AudioPlayer'),
  {
    ssr: false,
  },
);

let playerSource = {
  hls: 'https://d9b1r7vrvrckj.cloudfront.net/what-is-cloud-computing_hls/what-is-cloud-computing_audio.m3u8',
  // hls: 'https://cdn.bitmovin.com/content/assets/art-of-motion-dash-hls-progressive/m3u8s/f08e80da-bf1d-4e3d-8899-f0f6155f6efa-audio-only.m3u8',
};

let duration = 0;

export default function Home({ params }: PostProps) {
  const post = getPostFromParams(params);

  if (!post) {
    notFound();
  }

  const [playStatus, setPlayStatus] = useState(false);
  const [value, setValue] = useLocalStorage('isPlaying', false);
  const [timeValue, setTimeValue] = useLocalStorage('isTime', 0);
  const [isTitleValue, setTitleValue] = useLocalStorage('isTitle', null);

  if (post.title === 'What is Cloud Computing?') {
    playerSource = {
      hls: 'https://d9b1r7vrvrckj.cloudfront.net/what-is-cloud-computing_hls/what-is-cloud-computing_audio.m3u8',
    };
    duration = (post.audioDuration || 0) * 60;
  } else if (post.title === 'How to deploy DynamoDB locally?') {
    playerSource = {
      hls: 'https://d9b1r7vrvrckj.cloudfront.net/how-to-deploy-dynamodb-locally_hls/how-to-deploy-dynamodb-locally_audio.m3u8',
    };
    duration = (post.audioDuration || 0) * 60;
  } else if (post.title === 'Can you freeze bread?') {
    playerSource = {
      hls: 'https://d9b1r7vrvrckj.cloudfront.net/can-you-freeze-bread_hls/can-you-freeze-bread_audio.m3u8',
    };
    duration = (post.audioDuration || 0) * 60;
  } else if (
    post.title === 'Single Sign-On with AWS Cognito and Azure Active Directory'
  ) {
    playerSource = {
      hls: 'https://d9b1r7vrvrckj.cloudfront.net/single-sign-on-with-aws-cognito-and-azure-active-directory_hls/single-sign-on-with-aws-cognito-and-azure-active-directory.m3u8',
    };
    duration = (post.audioDuration || 0) * 60;
  } else if (post.title === 'A nightmare with input and output tokens') {
    playerSource = {
      hls: 'https://d9b1r7vrvrckj.cloudfront.net/a-nightmare-with-input-and-output-tokens_hls/a-nightmare-with-input-and-output-tokens.m3u8',
    };
    duration = (post.audioDuration || 0) * 60;
  }

  return (
    <>
      <div id="root"></div>
      <article className="py-6 prose dark:prose-invert">
        <h1 className="mb-4">{post.title}</h1>
        {post.description && <p>{post.description}</p>}
        <time dateTime={post.date} className="mb-2 block text-xs text-gray-600">
          {format(parseISO(post.date || ''), 'LLLL d, yyyy')}
        </time>
        <span className="mb-2 block text-xs text-gray-600">
          {post.readingTime}
        </span>
        <ListenAction
          duration={duration}
          playStatus={playStatus}
          setPlayStatus={setPlayStatus}
        />
        <hr />
        <Mdx code={post.body.code} />
      </article>
      <DynamicAudioPlayer
        playerSource={playerSource}
        playStatus={playStatus}
        setPlayStatus={setPlayStatus}
        value={value}
        setValue={setValue}
        setTimeValue={setTimeValue}
        setTitleValue={setTitleValue}
      />
    </>
  );
}
